import React from "react";
import { PdfViewer } from "../../../components";
import { MAIN_IMAGE_ROOT } from "../../../app_config";

interface Props {
  url: string;
}

const DocumentFile: React.FC<Props> = (props): React.ReactElement => {
  return <PdfViewer file={`${MAIN_IMAGE_ROOT}${props.url}`} />;
};

export default DocumentFile;
